import { inspectPromotionalAdImageBytes } from './promotional-ad-image-signature';
import {
  ACCEPTED_PROMOTIONAL_AD_IMAGE_MIME,
  MAX_PROMOTIONAL_AD_IMAGE_BYTES,
  type AcceptedPromotionalAdImageMime,
  type PromotionalAdImageExtension,
  type PromotionalAdImageValidationError,
  type ValidatedPromotionalAdImage,
} from '../types/promotional-ad';

export function isAcceptedPromotionalAdMime(
  mime: string | null | undefined,
): mime is AcceptedPromotionalAdImageMime {
  return !!mime && Object.prototype.hasOwnProperty.call(ACCEPTED_PROMOTIONAL_AD_IMAGE_MIME, mime);
}

export function getPromotionalAdFileExtension(mime: string): PromotionalAdImageExtension {
  if (isAcceptedPromotionalAdMime(mime)) return ACCEPTED_PROMOTIONAL_AD_IMAGE_MIME[mime];
  return 'jpg';
}

export async function validatePromotionalAdImageFile(
  file: File | null | undefined,
): Promise<ValidatedPromotionalAdImage | PromotionalAdImageValidationError> {
  if (typeof File === 'undefined' || !(file instanceof File) || file.size === 0) {
    return 'imageRequired';
  }
  if (file.size > MAX_PROMOTIONAL_AD_IMAGE_BYTES) return 'imageTooLarge';
  if (!isAcceptedPromotionalAdMime(file.type)) return 'imageInvalidType';

  const bytes = new Uint8Array(await file.arrayBuffer());
  const inspection = inspectPromotionalAdImageBytes(bytes, file.type);
  if (typeof inspection === 'string') return inspection;

  return {
    file,
    mimeType: inspection.mimeType,
    extension: getPromotionalAdFileExtension(inspection.mimeType),
    width: inspection.width,
    height: inspection.height,
  };
}
